import React, { useEffect, useMemo } from 'react';
import _get from 'lodash/get';
import {
  FilterGroupingEnum,
  useEdmDocumentationsIdsQuery,
} from 'graphql-common';
import { Option } from '@lib/interfaces/form';

export default function useDocumentationLinksPrefill({
  groupKey,
  initialDocumentationLinksRef,
  skip = false,
}: {
  groupKey?: string;
  initialDocumentationLinksRef?: React.MutableRefObject<Option[]>;
  skip?: boolean;
}) {
  const { data, loading, error } = useEdmDocumentationsIdsQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      onlyIds: true,
      filters: [
        {
          documentationTaskGroupsGroupKey: {
            grouping: FilterGroupingEnum.And,
            predicate: { in: [groupKey || ''] },
          },
        },
      ],
    },
    skip: !groupKey || skip,
  });

  const initialDocumentationLinks: Option[] = useMemo(() => {
    const ids = _get(data, 'data.collection', []) as Array<{ id: string }>;
    return ids.map(({ id }) => ({ value: id }));
  }, [data]);

  useEffect(() => {
    if (!groupKey || !data) return;
    if (initialDocumentationLinksRef) {
      // eslint-disable-next-line no-param-reassign
      initialDocumentationLinksRef.current = initialDocumentationLinks;
    }
  }, [data, groupKey, initialDocumentationLinks, initialDocumentationLinksRef]);

  return {
    initialDocumentationLinks,
    loading: Boolean(groupKey) && !skip && !error && (loading || !data),
  };
}
